import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CurrentUser } from '../../models/current-user';
import { AuthService } from '../../auth.service';
import { UserInformationService } from '../../services/user-information.service';
import { resourceServerUrl } from '../../constants/auth-keys';
import { HeaderService } from './header.service';

declare var $: any;

@Component({
  selector: 'umr-portal-header',
  templateUrl: './header.component.html',
  styleUrls: ["./header.component.css"],
  providers: [HeaderService]
})
export class HeaderComponent implements OnInit {
  defaultPhoto: string = "assets/img/doctor.png";
  userInformation: CurrentUser;
  currentUserPhoto: string;
  menu: any[] = [];
  proxy: any;
  allNotifications: any[] = [];
  notifications: any[] = [];
  displayNotifications: any[] = [];
  paginatorConfig = { rows: 5, pageLinkSize: 3 };

  constructor(private route: ActivatedRoute,
    private authService: AuthService,
    private userInformationService: UserInformationService,
    private headerService: HeaderService) {

    this.userInformationService.headerInformationSource.asObservable()
      .subscribe(data => {
        if (data && data.status === 200) {
          this.userInformation = data.body;
        }
      });
    this.userInformationService.headerPhotoSource.asObservable()
      .subscribe(data => {
        if (data && data != '') {
          this.currentUserPhoto = data;
        }
      });
  }

  ngOnInit() {
    if (this.route.snapshot.data["main"]) {
      this.route.data
        .subscribe(data => {
          if (!!data['main'][0] && data['main'][0] != '') {
            this.currentUserPhoto = "data:image/png;base64," + data['main'][0];
          }
          else {
            this.currentUserPhoto = this.defaultPhoto;
          }
          if (data['main'][1].status === 200) {
            this.userInformation = data['main'][1].body;
          }
          if (data['main'][2].length > 0) {
            const menuValues = ['ADUI12', 'ADUS01', 'ADCP13', 'DRPC01'];
            for (const item of data['main'][2]) {
              if (menuValues.lastIndexOf(item.MENU_VALUE) > -1) {
                this.menu.push(item);
              }
            }
          }
        });
    }
    this.prepareSignalR();
    this.handleNotification('');
  }
  prepareSignalR() {
    if (!resourceServerUrl.includes('localhost')) {
      this.prepareSignalRJquery();
      this.proxy = $.connection.notificationHub;

      this.proxy.client.receiveNotification = (message: string) => {
        this.handleNotification(message);
      };

      $.connection.hub.logging = true;
      $.connection.hub.start()
        .done((result) => { })
        .fail(function (reason) { /*console.log("Reason: ", reason);*/ });
    }
  }
  private prepareSignalRJquery() {
    $.connection = this.getWindow().dollar_dot_connection;
  }
  getWindow(): any {
    return window;
  }
  notificationClicked(notification) {
    //console.log('notification: ', notification);
    if (!resourceServerUrl.includes('localhost')) {
      if (notification.isSOAP) {
        //dismissNotification
        this.proxy.server.updateSeenStatus(notification.SoapAddressID)
          .done(() => { /*console.log('updateSeenStatus succeeded');*/ })
          .fail((error) => console.error('updateSeenStatus failed. ' + error));
      }
      else if (!notification.isSOAP) {
        //dismissAMDNotification
        this.proxy.server.clearAMDResponsibile(notification.PatientKey)
          .done(() => { /*console.log('clearAMDResponsibile succeeded');*/ })
          .fail((error) => console.error('clearAMDResponsibile failed. ' + error));
      }
      //this.proxy.server.notify('3')
      //    .done(() => { /*console.log('Invocation of notify succeeded');*/ })
      //    .fail((error) => console.error('Invocation of notify failed. Error: ' + error));
    }
  }
  overlay() {
    if ($("body").hasClass("overlay-open")) {
      $("body").removeClass("overlay-open");
    } else {
      $("body").addClass("overlay-open");
    }
  }

  logout() {
    this.authService.logout();
  }
  handleNotification(message: string) {
    this.headerService.getNotification()
      .subscribe(
        response => {
          this.notifications = [];
          if ((response as any).body) {
            const modifiedNotification = (response as any).body.map(notify => {
              return {
                ...notify
              }
            });
            this.notifications = [...modifiedNotification];
            this.displayNotifications = [...this.notifications];
            //console.log('Notification count: ', this.displayNotifications.length);
          }
        },
        err => {
          console.log('Notification error: ', err);
        },
      () => {
        //console.log('Notification done');
      }
      );
  }
  //paginate(event) {
  //    //event.first = Index of the first record
  //    //event.rows = Number of rows to display in new page
  //    //event.page = Index of the new page
  //    //event.pageCount = Total number of pages
  //    const index: number = (event.page * event.rows);
  //    this.displayNotifications = this.notifications.slice(index, index + Number.parseInt(event.rows));
  //    //console.log('notify: ', event, this.notifications, this.displayNotifications);
  //}
}
